import { Default, Detail, List, Create } from "./views";



const Module = {
    name: "businessunits",
    defaultRoutePath: "/legalentities/businessunit",
    menuItemScope: "legalentities",
    menuItemName: "businessunits",

    routes: [
        {
            path: "/legalentities/businessunit",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
